import { useMemo } from "react";

import Timestamp from "components/Timestamp";
import { makeTimestampToCopy } from "ds/components/Table/helpers";
import makeUseCellCopyAction from "ds/components/Table/helpers/makeUseCellCopyAction";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

import EnvironmentTableCell from "../Cell";
import { EnvironmentVariableCellProps } from "./types";

const useCellCopyAction = makeUseCellCopyAction();

const TimestampCell = ({ item, ...cellProps }: EnvironmentVariableCellProps) => {
  const createdAt = item.element.createdAt;

  const copyAction = useCellCopyAction({ text: makeTimestampToCopy(createdAt ?? 0) });
  const actions = useMemo(() => (createdAt ? [copyAction] : []), [copyAction, createdAt]);

  return (
    <EnvironmentTableCell {...cellProps} actions={actions}>
      {!!createdAt && <Timestamp timestamp={createdAt} />}
      {!createdAt && <TableCellEmpty />}
    </EnvironmentTableCell>
  );
};

export default TimestampCell;
